/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ContractDepartmentDepartmentDto,
  UpdateContractDepartmentDto
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getContractDepartmentGetOrganigramUrl = () => {


  

  return `/api/ContractDepartment/GetOrganigram`
}

export const contractDepartmentGetOrganigram = async ( options?: RequestInit): Promise<ContractDepartmentDepartmentDto[]> => {
  
  return customInstance<ContractDepartmentDepartmentDto[]>(getContractDepartmentGetOrganigramUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getContractDepartmentGetOrganigramQueryKey = () => {
    return [
    `/api/ContractDepartment/GetOrganigram`
    ] as const;
    }

    
export const getContractDepartmentGetOrganigramQueryOptions = <TData = Awaited<ReturnType<typeof contractDepartmentGetOrganigram>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractDepartmentGetOrganigram>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractDepartmentGetOrganigramQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractDepartmentGetOrganigram>>> = ({ signal }) => contractDepartmentGetOrganigram({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contractDepartmentGetOrganigram>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ContractDepartmentGetOrganigramQueryResult = NonNullable<Awaited<ReturnType<typeof contractDepartmentGetOrganigram>>>
export type ContractDepartmentGetOrganigramQueryError = ErrorType<unknown>


export function useContractDepartmentGetOrganigram<TData = Awaited<ReturnType<typeof contractDepartmentGetOrganigram>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractDepartmentGetOrganigram>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractDepartmentGetOrganigram>>,
          TError,
          Awaited<ReturnType<typeof contractDepartmentGetOrganigram>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContractDepartmentGetOrganigram<TData = Awaited<ReturnType<typeof contractDepartmentGetOrganigram>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractDepartmentGetOrganigram>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractDepartmentGetOrganigram>>,
          TError,
          Awaited<ReturnType<typeof contractDepartmentGetOrganigram>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContractDepartmentGetOrganigram<TData = Awaited<ReturnType<typeof contractDepartmentGetOrganigram>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractDepartmentGetOrganigram>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useContractDepartmentGetOrganigram<TData = Awaited<ReturnType<typeof contractDepartmentGetOrganigram>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractDepartmentGetOrganigram>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getContractDepartmentGetOrganigramQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getContractDepartmentGetOrganigramSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof contractDepartmentGetOrganigram>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractDepartmentGetOrganigram>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractDepartmentGetOrganigramQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractDepartmentGetOrganigram>>> = ({ signal }) => contractDepartmentGetOrganigram({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractDepartmentGetOrganigram>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ContractDepartmentGetOrganigramSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof contractDepartmentGetOrganigram>>>
export type ContractDepartmentGetOrganigramSuspenseQueryError = ErrorType<unknown>


export function useContractDepartmentGetOrganigramSuspense<TData = Awaited<ReturnType<typeof contractDepartmentGetOrganigram>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractDepartmentGetOrganigram>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContractDepartmentGetOrganigramSuspense<TData = Awaited<ReturnType<typeof contractDepartmentGetOrganigram>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractDepartmentGetOrganigram>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContractDepartmentGetOrganigramSuspense<TData = Awaited<ReturnType<typeof contractDepartmentGetOrganigram>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractDepartmentGetOrganigram>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useContractDepartmentGetOrganigramSuspense<TData = Awaited<ReturnType<typeof contractDepartmentGetOrganigram>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractDepartmentGetOrganigram>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getContractDepartmentGetOrganigramSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getContractDepartmentUpdateContractDepartmentUrl = () => {


  

  return `/api/ContractDepartment/UpdateContractDepartment`
}

export const contractDepartmentUpdateContractDepartment = async (updateContractDepartmentDto: UpdateContractDepartmentDto, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getContractDepartmentUpdateContractDepartmentUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateContractDepartmentDto,)
  }
);}




export const getContractDepartmentUpdateContractDepartmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractDepartmentUpdateContractDepartment>>, TError,{data: BodyType<UpdateContractDepartmentDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof contractDepartmentUpdateContractDepartment>>, TError,{data: BodyType<UpdateContractDepartmentDto>}, TContext> => {

const mutationKey = ['contractDepartmentUpdateContractDepartment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof contractDepartmentUpdateContractDepartment>>, {data: BodyType<UpdateContractDepartmentDto>}> = (props) => {
          const {data} = props ?? {};

          return  contractDepartmentUpdateContractDepartment(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContractDepartmentUpdateContractDepartmentMutationResult = NonNullable<Awaited<ReturnType<typeof contractDepartmentUpdateContractDepartment>>>
    export type ContractDepartmentUpdateContractDepartmentMutationBody = BodyType<UpdateContractDepartmentDto>
    export type ContractDepartmentUpdateContractDepartmentMutationError = ErrorType<unknown>

    export const useContractDepartmentUpdateContractDepartment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractDepartmentUpdateContractDepartment>>, TError,{data: BodyType<UpdateContractDepartmentDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof contractDepartmentUpdateContractDepartment>>,
        TError,
        {data: BodyType<UpdateContractDepartmentDto>},
        TContext
      > => {

      const mutationOptions = getContractDepartmentUpdateContractDepartmentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    